import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconClapboard"><Path d="M21 21H3V9.5H21V21Z" fill="currentColor"/><Path d="M7.20898 8H3V3H8.87598L7.20898 8Z" fill="currentColor"/><Path d="M13.459 8H8.79102L10.458 3H15.126L13.459 8Z" fill="currentColor"/><Path d="M21 8H15.041L16.708 3H21V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboard;
